import React from 'react';

export default function SimpleTable({ title, columns = [], rows = [] }) {
    return (
        <div className="dashboard-new-card">
            {title ? <h3>{title}</h3> : null}
            <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            {columns.map((col, idx) => (
                                <th key={`col-${idx}`} style={{ textAlign: 'left', padding: '0.5rem 0.75rem', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                                    {typeof col === 'string' ? col : col?.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, rIdx) => (
                            <tr key={`row-${rIdx}`}>
                                {columns.map((col, cIdx) => {
                                    const key = typeof col === 'string' ? col : col?.key;
                                    return (
                                        <td key={`cell-${rIdx}-${cIdx}`} style={{ padding: '0.5rem 0.75rem', borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
                                            {row?.[key]}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}


